export const paymentContent = {
  CASH: {
    footnote:
      "A cash payment to be specified upon completion of Trade In and once your device has been assessed.",
    payout: "Cash payout",
    tooltipContent:
      "This will be paid by Bank transfer or PayPal. Payout can take up to 3 working days after inspection.",
    summaryNote:
      "After checkout, you'll receive an email asking for more details about how you'd like to be paid. You'll receive this amount once your device has been received and assessed.",
  },
  GIFT_CARD: {
    footnote:
      "John Lewis gift card payment to be specified upon completion of Trade In and once your device has been assessed.",
    payout: "John Lewis e-gift card",
    tooltipContent:
      "This will be sent to you by email. Payout can take up to 3 working days after inspection.",
    summaryNote:
      "This will be sent to you by email up to 3 working days after inspection.",
  },
};
